
















































import { Component, Vue, Mixins } from 'vue-property-decorator'
import 'muse-ui/lib/styles/base.less'
import { Icon, Button, Tabs, Carousel} from 'muse-ui'
import axios from 'axios'
import {ConfigMixin} from '@/mixins/ConfigMixin'
import NormalCard from '@/components/match/NormalCard.vue'
import WatchNormalCard from '@/components/matchWatch/NormalCard.vue'
import SetCard from '@/components/match/SetCard.vue'
Vue.use(Icon)
Vue.use(Button)
Vue.use(Tabs)
Vue.use(Carousel)

@Component({
  components: {
    'normal-card': NormalCard,
    'set-card': SetCard,
    'w-normal-card': WatchNormalCard,
  },
})
export default class MatchList extends Mixins(ConfigMixin) {
  private tab: number = 0
  private matchList: any = []
  private activeTab: number = 0
  private watchList: any = []
  private created() {
    this.apiGetMatchList(0)
  }
  private tabChange() {
    if (this.activeTab === 1) {
      this.apiGetWatchList()
    }
  }
  private getCardLeftColor(index: number) {
    switch (index % 4) {
      case 0:
      return 'background-color:#e93525;'
      case 1:
      return 'background-color:#fbb200;'
      case 2:
      return 'background-color:#1c9d3e;'
      case 3:
      return 'background-color:#2d77f3;'
      default:
      return 'background-color:#e93525;'
    }
  }
  // api 获取赛事列表
  private apiGetMatchList(zoneid: number) {
    axios.post('/m/apply/api-get-match-list', {
      zoneid,
    }).then(({data}) => {
      this.matchList = data.data
    })
  }
  // 获取观赛列表
  private apiGetWatchList() {
    axios.get('/m/apply/api-get-watch-list').then(({data}) => {
      this.watchList = data.data
    })
  }
}
